import React from 'react';
import { Field } from 'redux-form/immutable';
import Checkbox from '../form/_Checkbox';
import PropTypes from 'prop-types';
import Immutable from 'immutable';

const AppointmentsLimit = ({ formValues, changeFormData, name }) => {
  return (
    <div style={ { flexDirection: 'row', display: 'flex', alignItems: 'center' } }>
      <Field component={ _renderCheckbox(formValues, changeFormData, name) }
        id='isLimitChecked'
        name='isLimitChecked'
        onChange={ _handleResetLimitByRep(formValues, changeFormData, name) }
        type='checkbox' />
      <Field className='form__field form__field--rounded'
        component={ _renderLimitSelect(formValues, changeFormData, name) }
        disabled={ !_isAppointmentLimitEnabled(formValues) }
        name='office.limitByRep'
        type='select' />
    </div>
  );
};

AppointmentsLimit.propTypes = {
  changeFormData: PropTypes.func.isRequired,
  formValues: PropTypes.instanceOf(Immutable.Map),
  name: PropTypes.string.isRequired
};

const _handleResetLimitByRep = (formValues, changeFormData, name) => () => {
  if (_isAppointmentLimitEnabled()(formValues)) {
    return changeFormData(`${name}.limitByRep`, 0);
  }
  return changeFormData(`${name}.limitByRep`, 1);
};

const _renderCheckbox = (formValues, changeFormData, name) => ({ input, meta, ...rest })  => {
  if (formValues && formValues.getIn([name, 'limitByRep']) > 0) {
    changeFormData('isLimitChecked', true);
  }
  return <Checkbox { ...input }
    { ...rest }
    checked={ input.checked }
    customstyle={ { marginTop: '20px' } } />;
};

const _isAppointmentLimitEnabled = () => (formValues) => {
  return formValues.get('isLimitChecked');
};

const _handleLimitChange = (changeFormData, name)  => (event) => {
  changeFormData(`${name}.limitByRep`, event.target.value);
};

const _renderLimitSelect = (formValues, changeFormData, name) => ()  => {
  const limitByRep = formValues.getIn([name, 'limitByRep']);
  const disabled = limitByRep === 0 || !limitByRep;

  return (
    <select className={ 'form__field form__select' } disabled={ disabled } onChange={ _handleLimitChange(changeFormData, name) } value={ limitByRep } >
      <option key={ 1 } value={ 1 }>1</option>
      <option key={ 2 } value={ 2 }>2</option>
      <option key={ 3 } value={ 3 }>3</option>
    </select>
  );
};

export default AppointmentsLimit;



// WEBPACK FOOTER //
// ./app/components/shared/managers/_AppointmentsLimit.jsx